import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

type AuthBackToSignInLinkProps = {
  className?: string
  disabled?: boolean
  label?: 'already-have-account' | 'back'
}

export function AuthBackToSignInLink({
  className,
  disabled,
  label = 'already-have-account',
}: AuthBackToSignInLinkProps) {
  return (
    <p className={cn('text-center text-sm text-muted-foreground', className)}>
      {label === 'back' ? 'Back to ' : 'Already have an account? '}
      <Link
        to="/login"
        className={cn(
          'font-semibold text-foreground underline-offset-4 hover:underline',
          disabled && 'pointer-events-none opacity-50',
        )}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
      >
        Sign in
      </Link>
    </p>
  )
}
